module.exports = __webpack_public_path__ + "static/img/no-bill@2x.0b3acbf1.png";